<template>
  <base-modal>
    <z-form ref="form" tag="div" @submit.native.prevent="save">
      <radio-group v-model="scheme_type" vertical>
        <radio label="media">
          <span> {{ $t('autoinformer.campaign.modal.create_scheme.option1') }}</span>
        </radio>
        <radio label="menu">
          <span> {{ $t('autoinformer.campaign.modal.create_scheme.option2') }}</span>
        </radio>
        <!-- TODO вернуть после того, как сделаем валидацию на то, чтобы элемент Автоинформатор был не один на схеме
        <radio label="default">
          <span> {{ $t('autoinformer.campaign.modal.create_scheme.option3') }}</span>
        </radio> -->
      </radio-group>
    </z-form>
    <i-button slot="footer-ok" size="large" type="primary" @click="open">
      {{ $t('autoinformer.campaign.modal.create_scheme.title') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';

  export default {
    components: { BaseModal },
    props: {
      scheme_type: {
        type: String,
        required: true
      }
    },
    methods: {
      open() {
        this.$emit('success', this.scheme_type);   
      }
    }
  };
</script>
